export const API_NAMES = {
  ODR_LIVE_MAP: 'ODRLiveMapBackend',
  EBPMS: 'EBPMSBackend' // Electronic Brake Performance Monitoring System
};
